import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {AdministrationService} from "../../core/services/gestion-administration/administration.service";
import {MSG_KEY, MSG_SEVERITY} from "../../core/constants";
import {ToastService} from "../../core/services/technique/toast.service";
import {Title} from "@angular/platform-browser";
import {GraphQLService} from "../../core/services/technique/graphql.service";
import {HistoryEventDto} from "../../core/dtos/history-event-dto";
import {UtilsService} from "../../core/utils/utils.service";
import {FilterFicheTechniqueModel} from "../../core/models/gestion-fiches-techniques/filter-fiche-technique-model";

@Component({
  selector: 'yo-gestion-administration',
  templateUrl: './gestion-administration.component.html',
  styleUrls: ['./gestion-administration.component.scss']
})
export class GestionAdministrationComponent implements OnInit {

  popupPurgeVisible: boolean = false;
  popupAllergenesVisible: boolean = false;
  popupMAJProduitsArticlesVisible: boolean = false;
  popupMAJBillsVisible: boolean = false;
  popupMAJArticlesWithPeriodPriceVisible: boolean = false;
  popupVisibleMAJ: boolean = false;

  dialogTitle: string;
  dialogTitleProgressBar: string;

  numberOfDishesProduced: number;

  batchSize: number = 500;
  totalBatches: number = 0;
  progress: number = 0;

  progressBarVisible: boolean = false;

  idUdpList: any[] = [];

  operationFilter: string = "Fin de la mise à jour des fiches techniques";
  descFilter: string = "Mise à jour des fiches techniques";

  constructor(public utils: UtilsService,
              private administrationService: AdministrationService,
              private graphQlSvc: GraphQLService,
              private title: Title,
              private cdr: ChangeDetectorRef,
              private toastSvc: ToastService) {
  }

  ngOnInit(): void {
    this.initData();
  }

  initData = (): void => {
    this.title.setTitle(this.getTitle());
    this.dialogTitle = 'Confirmation';
    this.dialogTitleProgressBar = 'Mise à jour des fiches techniques';
    this.findNumberOfDishesProduced();
    this.findAllUdp();
    this.findParametersForFicheTechniqueMAJ();
  }

  private findParametersForFicheTechniqueMAJ = () => {
    const now: number = Date.now();
    const yesterday: number = now - 2 * (24 * 60 * 60 * 1000);

    this.graphQlSvc.sendQuery(`
      {
          allHistoryEventsByArgs(filters: {
          operation: "${this.operationFilter}",
          description: "${this.descFilter}",
          date: "${yesterday.toString()}"
        }) {
          ${HistoryEventDto.getAllGraphQlProperties()}
        }
      }
    `).subscribe(result => {
      if (result) {
        const lastHistoryEvent = result.allHistoryEventsByArgs.reduce((prev, curr) => {
          const prevDiff = Math.abs(new Date(prev.dateTime).getTime() - now);
          const currDiff = Math.abs(new Date(curr.dateTime).getTime() - now);
          return currDiff < prevDiff ? curr : prev;
        });

        if (lastHistoryEvent) {
          const parsed = JSON.parse(lastHistoryEvent.args) as {
            progress?: number;
            batchSize?: number;
            numberOfDishesProduced?: number;
          };

          this.progress = parsed.progress ?? 0;
          this.batchSize = parsed.batchSize ?? 500;
        }
      }
    });
  };

  private findNumberOfDishesProduced() {
    this.administrationService.findNumberOfDishesProduced()
      .subscribe(result => {
        this.numberOfDishesProduced = result.one;
        this.totalBatches = Math.ceil(this.numberOfDishesProduced / this.batchSize);
      });
  }

  findAllUdp = (): void => {
    this.graphQlSvc.sendQuery(`
      {
          allUnitesProduction {
              id
          }
      }
    `)
      .subscribe((res) => {
        this.idUdpList = res.allUnitesProduction;
      });
  }

  getTitle = (): string => "GESTION ADMINISTRATION";

  purgeInactiveArticles = async (): Promise<void> => {
    this.administrationService.purgeInactiveArticles()
      .subscribe(response => {
        this.closeDialogPurge();
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `La suppression a été réalisée avec succès`);
      })
  }

  updateProduitsArticles = async (): Promise<void> => {
    this.administrationService.updateProduitsArticles()
      .subscribe(response => {
        this.closeDialogMAJProduitsArticles();
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `La mise à jour a été réalisée avec succès`);
      })
  }

  updateArticlesWithPeriodPrice = async (): Promise<void> => {
    this.administrationService.updateArticlesWithPeriodPrice()
      .subscribe(response => {
        this.closeDialogMAJArticlesWithPeriodPrice();
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `La mise à jour a été réalisée avec succès`);
      })
  }

  updateBills = async (): Promise<void> => {
    this.administrationService.updateBills()
      .subscribe(response => {
        this.closeDialogMAJBills();
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `La mise à jour a été réalisée avec succès`);
      })
  }

  majAllergenes = async (): Promise<void> => {
    this.administrationService.majAllergenes()
      .subscribe(response => {
        if (response.one) {
          this.closeDialogAllergenes();
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `La mise à jour a été réalisée avec succès`);
        }
      })
  }

  majFichesTechniques = async (majPlat: boolean): Promise<void> => {
    this.closeDialogMAJ();
    this.cdr.detectChanges();
    this.showPopupProgressBar();
    let current = this.progress;
    let filter: FilterFicheTechniqueModel = new FilterFicheTechniqueModel();
    filter.majPlat = majPlat;
    filter.numberOfDishesProduced = this.numberOfDishesProduced;
    filter.progress = this.progress;
    filter.batchSize = this.batchSize;

    const sendNextBatch = () => {
      if (current >= this.totalBatches) {
        if (majPlat) {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `La mise à jour des fiches techniques a été réalisée avec succès`);
          this.closePopupProgressBar();
        }
        return;
      }

      this.administrationService.majFichesTechniques(filter)
        .subscribe(response => {
          if (response.one) {
            this.progress = current + 1;
            filter.progress = this.progress;
            current++;
            sendNextBatch();
          }
        });
    };

    sendNextBatch();
  }

  format = ratio => `Progression : ${Math.round(ratio * 100)}%`;

  showPopupPurge = () => this.popupPurgeVisible = true;
  showPopupAllergenes = () => this.popupAllergenesVisible = true;
  showPopupMAJProduitsArticles = () => this.popupMAJProduitsArticlesVisible = true;
  showPopupMAJBills = () => this.popupMAJBillsVisible = true;
  showPopupMAJArticlesWithPeriodPrice = () => this.popupMAJArticlesWithPeriodPriceVisible = true;
  showPopupMAJ = () => this.popupVisibleMAJ = true;
  showPopupProgressBar = () => this.progressBarVisible = true;

  closeDialogPurge = () => this.popupPurgeVisible = false;
  closeDialogAllergenes = () => this.popupAllergenesVisible = false;
  closeDialogMAJProduitsArticles = () => this.popupMAJProduitsArticlesVisible = false;
  closeDialogMAJBills = () => this.popupMAJBillsVisible = false;
  closeDialogMAJArticlesWithPeriodPrice = () => this.popupMAJArticlesWithPeriodPriceVisible = false;
  closeDialogMAJ = () => this.popupVisibleMAJ = false;
  closePopupProgressBar = () => this.progressBarVisible = false;
}
